import type { ReactNode } from 'react'

import styles from './CockpitCollapsedMetricGroup.module.scss'

interface ICockpitCollapsedMetricGroupProps {
  children: ReactNode
}

export const CockpitCollapsedMetricGroup = ({ children }: ICockpitCollapsedMetricGroupProps) => (
  <div className={styles.root}>{children}</div>
)

CockpitCollapsedMetricGroup.displayName = 'CockpitCollapsedMetricGroup'
